import styled from "@emotion/styled";

export const IntegrationData = styled('div')((p) => ({
    display: 'grid',
    gridTemplateColumns: 'max-content 2fr',
    gridColumnGap: p.theme.spacing(3),
    gridRowGap: p.theme.spacing(1),
    fontFamily: `'Courier', mono`,
    fontSize: p.theme.custom.fontSize.s,
    padding: p.theme.spacing(2),
    color: p.theme.custom.colors.gray.w900,
    backgroundColor: p.theme.custom.colors.gray.w100
  }));